import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import BlockquoteRecommendation from "../c64_blockquote/c64_blockquote";

import "./c54b_quote.scss";
import {columnLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";


interface C54BQuoteData {
    blockquote_text: string;
    blockquote_author?: string;
    blockquote_subtitle?: string;
    content: string;
}

/**
 * The component C54B renders a quote and some editor-defined html.
 *
 * If we are on desktop (on a single column layout),
 * the quote block is on the left and fills 5/12 of the page width,
 * while the editor-defined html is on the right.
 *
 * On mobile, the editor-defined html is below the quote block.
 */
class C54BQuote extends TemplateComponent<C54BQuoteData, TemplateComponentProps<C54BQuoteData>> {

    componentRender(data: C54BQuoteData): React.ReactElement<any> {
        return (
            <Container className="c54b-quote" fluid={true}>
                <Row>
                    <Col {...columnLayout(5)}>
                        <div className="quote-container">
                            <BlockquoteRecommendation data={data} layoutColumns={this.props.layoutColumns} language={this.props.language}/>
                        </div>
                    </Col>
                    <Col {...columnLayout(7)} className="content-container-col">
                        <div className="content editor-html editor-html-right-col" {...insertHtml(data.content)} />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default C54BQuote;